module.exports = __webpack_public_path__ + "static/img/scenes_icon_holiday.c9f9813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenes_icon_holiday.png
// module id = tBqa
// module chunks = 1